import React from 'react';
import { formTextbox, formTextarea, formTextboxContainer, formTextboxLabel } from "../../../Constants/Styles";

const styles = {
  overlay: "fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50",
  modalContainer: "w-[40rem] bg-white p-6 shadow-lg rounded-lg", // Fixed width, removed duplicate class name
  title: "font-proximanova mb-4 text-[22px] font-[600] mb-0",
  formGroup: "mb-[16px]",
  label: "block text-sm md:text-md 2xl:text-lg font-medium text-gray-700",
  input: "mt-0.5 block w-full px-3 py-1 border border-gray-300 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 font-proximanova text-[18px]",
  inputSmall: "mt-1 block w-full px-3 py-2 border border-gray-300 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 font-proximanova text-[18px] w-2/3", // For email input
  buttonPrimary: "mt-[4px] px-2 py-1 bg-charmOrange font-proximanova text-[16px] text-white rounded-md flex items-center", // Fixed class names for button
  buttonSecondary: "px-2 py-1 bg-red text-white rounded-md mr-2",
  spinner: "spinner-border spinner-border-sm mr-2",
  textCenter: "mb-4 text-center font-proximanova text-[16px] text-[#505050]",
  linkButton: "text-md px-1 font-proximanova text-[16px] text-[#2563eb] hover:text-[#60a5fa]",
  textArea: "h-[5rem] mt-1 block w-full px-3 py-2 border border-gray-300 rounded-none shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-md md:text-lg 2xl:text-xl",
  buttonGroup: "flex flex-row items-center justify-end gap-[12px]",
  flexRow: "flex flex-row items-center justify-center", // Flex row for email and OTP button
};

const SubmitRequestModal = ({
  isSignedIn,
  handleSubmit,
  handleCloseModal,
  handleLogin,
  handleSendOtp,
  setOtpEmail,
  otpLoading,
  orderRequestLoading
}) => {

  return (
    <div className={styles.overlay}>
      <div className={`${styles.modalContainer} ${isSignedIn ? 'h-auto' : 'h-fit'}`}>
        <h3 className={styles.title}>Submit a Request</h3>
        <form onSubmit={handleSubmit}>
          {!isSignedIn && (
            <>
              <div className={styles.formGroup}>
                <label htmlFor="name" className={formTextboxLabel}>
                  Your Name
                  <span style={{ color: '#9a016a' }}>*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  className={styles.input}
                  required
                />
              </div>
              <div className={styles.formGroup}>
                <label htmlFor="email" className={formTextboxLabel}>
                  Your Email
                  <span style={{ color: '#9a016a' }}>*</span>
                </label>
                <div className={styles.flexRow}>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className={styles.inputSmall} // Adjusted width for email input
                    required
                    onChange={(e) => setOtpEmail(e.target.value)}

                  />
                  <button
                    type="button"
                    className={styles.buttonPrimary}
                    onClick={handleSendOtp}
                    disabled={otpLoading}
                    style={{ lineHeight: '1.2' }}
                  >
                    {otpLoading && (
                      <span className={styles.spinner} role="status" aria-hidden="true"></span>
                    )}
                    {otpLoading ? 'Sending OTP...' : 'Send OTP'}
                  </button>
                </div>
              </div>
              <div className={styles.formGroup}>
                <label htmlFor="otp" className={formTextboxLabel}>
                  Enter OTP
                  <span style={{ color: '#9a016a' }}>*</span>
                </label>
                <input
                  type="text"
                  id="otp"
                  name="otp"
                  placeholder="Enter the OTP you received"
                  className={styles.input}
                  required
                />
              </div>
              {/* <div className={styles.formGroup}>
                <label htmlFor="practiceName" className={formTextboxLabel}>
                  Practice Name
                 <span style={{ color: '#9a016a' }}>*</span>
                </label>
                <input
                  type="text"
                  id="practiceName"
                  name="practiceName"
                  className={styles.input}
                  required
                />
              </div> */}
            </>
          )}
          <div className={styles.formGroup}>
            <label htmlFor="practiceName" className={formTextboxLabel}>
              Practice Name
              <span style={{ color: '#9a016a' }}>*</span>
            </label>
            <input
              type="text"
              id="practiceName"
              name="practiceName"
              className={styles.input}
              requir
            />
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="message" className={formTextboxLabel}>
              Message
              <span style={{ color: '#9a016a' }}>*</span>
            </label>
            <textarea
              id="message"
              name="message"
              style={{ resize: 'none' }}
              placeholder="Please specify the number of providers in your practice and how you are planning to use this Add-On."
              className={styles.textArea}
              required
            ></textarea>
          </div>
          {!isSignedIn && (
            <div className={styles.textCenter}>
              Have a CharmHealth account?
              <button onClick={handleLogin} className={styles.linkButton}>
                Log in
              </button>
            </div>
          )}
          <div className={styles.buttonGroup}>
            <button
              type="button"
              className="w-fit text-white bg-red hover:text-integrationRequestTextHover hover:bg-charmHover rounded-full text-[18px] font-proximanova px-6 py-1"
              onClick={handleCloseModal}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="w-fit text-white bg-link hover:text-integrationRequestTextHover hover:bg-charmHover rounded-full text-[18px] font-proximanova px-6 py-1"
              disabled={orderRequestLoading}
            >
              {orderRequestLoading && (
                <span className={styles.spinner} role="status" aria-hidden="true"></span>
              )}
              {orderRequestLoading ? 'Submitting' : 'Submit Request'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SubmitRequestModal;